<div class="firstDiv"><h5 class="ShippingHeading">Terms of Service</h5></div>

<div  class="secondDiv">
    <p class="shippingPara">
      Welcome to FRRANKY. These Terms of Service; govern your use of our website, mobile application (if applicable) and any purchase of products offered by FRRANKY (referred to as “we,” “our,” “us,” or “FRRANKY”).
      By accessing or using our services, you agree to comply with and be bound by the following terms. Please read them carefully.
      <br>
    </p><h5 class="SubHeadings">
    1. Eligibility</h5>
   <p class="para">You must be at least 18 years old or accessing the site under the supervision of a parent or legal guardian. By using our services, you represent that you have the legal capacity to enter into these Terms.
  </p>
    
    
    <h5 class="SubHeadings">2.  Account Registration</h5>
    <p class="para">You may be required to create an account to access certain features. You are responsible for maintaining the confidentiality of your account and password and for restricting access to your device. You agree to accept responsibility for all activities that occur under your account.

   <h5 class="SubHeadings">3. Products and Pricing</h5> 
   <p class="para">All prices are listed in INR (₹) and are inclusive of applicable taxes unless stated otherwise.


    We strive to provide accurate product descriptions, but we do not warrant that descriptions, images, or other content are accurate, complete, reliable, current, or error-free.
    
    
    Prices and availability are subject to change without notice.
    
    
    
   <h5 class="SubHeadings">4. Orders and Acceptance</h5> 
   <p class="para">Your order represents an offer to purchase products from us.


    We reserve the right to accept or reject any order at our sole discretion.
    
    
    Order confirmation will be provided via email or SMS.</p>
    
    
   <h5 class="SubHeadings">5. Payment</h5>
   <p class="para">We currently accept forms of online payment via UPI through secure third-party payment. All payments must be authorized before the order is confirmed.
  </p>
    
    
    
    <h5 class="SubHeadings">6. Shipping and Delivery</h5>
    <p class="para">We ship PAN India. Shipping times may vary depending on location and logistics partner.


      Estimated delivery times are 5–7 business days unless otherwise specified.
      
      
      Delays due to unforeseen circumstances such as weather, strikes, or courier issues are beyond our control.
      
      
      For more, refer to our [Shipping Policy].
        </p>
    
        <h5 class="SubHeadings">7. Returns and Exchanges</h5>
        <p class="para">Items can be returned or exchanged within 7 days of receiving your order.


          Items must be unused, unwashed and returned in original packaging with tags intact.
          
          
          Refunds will be processed only after quality checks.
          
          
          (For full details, see our [Return & Refund Policy].)</p>
          <h5 class="SubHeadings">8. Intellectual Property Rights</h5>
          <p class="para">All content, graphics, logos, icons, images and design elements on our website are the property of FRRANKY or its content suppliers and are protected by copyright, trademark, and other intellectual property laws.
            You may not use, reproduce, distribute, modify, or publicly display any portion of our content without prior written consent.
            </p>
            <h5 class="SubHeadings">9. User Conduct </h5>
            <p class="para"> You agree not to:
              Violate any local, state, national, or international law.
              
              
              Infringe on our intellectual property rights or those of others.
              
              
              Upload or transmit harmful software or content.
              
              
              Attempt to gain unauthorized access to our systems or interfere with service functionality. </p>
    
              <h5 class="SubHeadings">10. Limitation of Liability</h5>
              <p class="para">FRRANKY shall not be liable for any direct, indirect, incidental, special, or consequential damages resulting from:
                The use or inability to use our services
                
                
                Unauthorized access to or alteration of your transmissions or data
                
                
                Any other matter relating to our services </p>
                <h5 class="SubHeadings">11. Indemnification</h5>
            <p class="para">You agree to indemnify and hold FRRANKY harmless from any claims, losses, liabilities, damages, and expenses arising out of your use of our services or your violation of these Terms.
            </p>
              <h5 class="SubHeadings">12. Termination</h5>
            <p class="para">We reserve the right to terminate or suspend access to our services at any time, with or without cause or notice, if we believe you have violated these Terms.
            </p>
             
              <h5 class="SubHeadings">13. Governing Law and Jurisdiction</h5>
            <p class="para">These Terms are governed by the laws of India. Any disputes shall be resolved under the exclusive jurisdiction of the courts located in our city.
            </p>
              <h5 class="SubHeadings">14. Updates to Terms</h5>
            <p class="para">We may update or revise these Terms from time to time. Continued use of the site after any such changes constitutes your consent to the updated Terms.

            </p>

   <h5 class="SubHeadings">15. Contact Us</h5>
   <p class="para">If you have any questions or concerns about these Terms, feel free to contact us:
     📧 Email: support@frranky.com<br>
     📞 Phone/WhatsApp: +91-9811308821<br>
   </p>
    </div>
    
